export default {
	'user-create': 'User create',
	'user-edit': 'User edit',
	'edit-account-status': 'Edit account status',
	'are-you-sure-to-deactivate-an-account': 'Are you sure to deactivate an account',
	'are-you-sure-to-activate-an-account': 'Are you sure to activate an account',
	'user-power': 'User power',
	'store-name': 'Store name',
	'power-type': 'Power type',
	casher: 'Casher',
	'executive-director': 'Store Director',
	optional: 'Optional',
	'change-password': 'Change password',
	'password-has-been-modified-successfully': 'Password has been modified successfully',
	active: 'Active',
	stopped: 'Stopped',
	'user-info': 'User data',
	'the-user-has-been-added-successfully': 'The user has been added successfully',
	'user-data-has-been-modified-successfully': 'User data has been modified successfully',
	viewer: 'Viewer',
	'user-permissions-for': 'User permissions for',
	permissions: {
		'permission-type': 'Permission type',
		allowed: 'Allowed',
		read: 'Read',
		'not-Allowed': 'Not Allowed',
	},
	permissionTypes: {
		configs: 'Store info',
		currencies: 'Currencies',
		users: 'Users',
		stores: 'Stores',
		cashboxes: 'Cashboxes',
		'account-statement': 'Account statement',
		'cash-journal': 'Cash journal',
		'closed-cash-journal': 'Closing cash journal',
		'all-cash-journal': 'Cash journals',
		'detailed-day': 'Daily journal',
		'daily-table': 'Daily table',
		'item-tree': 'Item tree',
		'sale-invoice': 'Sale invoice',
		'buy-invoice': 'Buy invoice',
		'sale-refund-invoice': 'Sale refund invoice',
		'all-invoices': 'All invoices',
		'items-journal': 'Items journal',
		'all-item-journals': 'All item journals',
		'item-statement': 'Item statement',
		'inventory-report': 'Inventory report',
		reports: 'Reports',
		'close-cash-journal': 'Close cash journal',
		'invoice-discount': 'Invoice discount',
		'invoice-change-account': 'Invoice account',
		'invoice-card': 'Invoice card payment',
		'invoice-internal': 'Invoice internal payment',
		'account-tree': 'Account tree',
		'invoice-debt': 'Invoice debt payment',
		'invoice-entries-discount': 'Invoice entries discount',
	}
}